module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started.d967c5a0.jpg";